import React, {useCallback, useState} from 'react';
import ReferenceForm from './ReferenceForm';
import ReferenceList from './ReferenceList';
import {useDispatch} from 'react-redux';
import {showModal} from '../../../../redux/system/actions';
import ConfirmModal from '../../../common/modals/ConfirmModal';
import { toast } from 'react-toastify';
import {COMPLETE_CURRICULUM_VITAE_REFERENCE_TOAST_MESSAGES, getErrorUpdateToastPropsBy, getSuccesToastPropsBy} from '../../../../service/toastService';
import { createCurriculumVitaeReference, updateCurriculumVitaeReference, deleteCurriculumVitaeReference } from '../../../../api/curriculumVitaeApi';

const CONFIRM_MODAL_ID = 'confirmModal';

function Reference({curriculumVitae, setCurriculumVitae}) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [references, setReferences] = useState(curriculumVitae.curriculumVitaeReferences || []);
    const [editingReference, setEditingReference] = useState(null);
    const [referenceToDelete, setReferenceToDelete] = useState(null);

    const handleSaveReference = async (referenceData) => {
        try {
            if(editingReference) {
                const updatedReference = await updateCurriculumVitaeReference(referenceData);
                const updatedReferences = references.map((ref) =>
                    ref.id === referenceData.id ? updatedReference.data : ref
            );
            setReferences(updatedReferences);
            setCurriculumVitae((prevCv) => ({
                ...prevCv,
                curriculumVitaeReferences: updatedReferences,
            }));

            toast.success('Reference updated successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_REFERENCE_TOAST_MESSAGES))
            }
            else {
                const newReference = await createCurriculumVitaeReference(referenceData);
                const updatedReferences = [...references, newReference.data];
                setReferences(updatedReferences);
                setCurriculumVitae((prevCv) => ({
                    ...prevCv,
                    curriculumVitaeReferences: updatedReferences,
                }))
    
                toast.success('Reference added successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_REFERENCE_TOAST_MESSAGES))
            }

            setEditingReference(null);
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_REFERENCE_TOAST_MESSAGES))
        }
    }

    const handleDeleteReference = async () => {
        if (!referenceToDelete) return;
        try {
            await deleteCurriculumVitaeReference(referenceToDelete);
            setReferences((prevReferences) => prevReferences.filter((exp) => exp.id !== referenceToDelete));
            setCurriculumVitae((prevCv) => {
                const updatedReferences = prevCv.curriculumVitaeReferences.filter((exp) => exp.id !== referenceToDelete);
                return {
                    ...prevCv,
                    curriculumVitaeReferences: updatedReferences,
                };
            });
            toast.success('Reference deleted successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_REFERENCE_TOAST_MESSAGES));
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_REFERENCE_TOAST_MESSAGES));
        }
    }

    const handleEditReference = (reference) => {
        setEditingReference(reference);
    };

    const confirmDeleteReference = (referenceId) => {
        setReferenceToDelete(referenceId);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    return (
        <div>
            <h4 className="mb-4" style={{textDecoration: 'underline', textUnderlineOffset: '7px'}}>
                Reference
            </h4>
            <ReferenceForm curriculumVitaeId={curriculumVitae.id} initialReference={editingReference} setEditingReference={setEditingReference}
                           onSave={handleSaveReference}/>
            <ReferenceList references={references} onEdit={handleEditReference} onDelete={confirmDeleteReference}/>

            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this reference?"
                message="This will permanently remove the selected reference from your profile. Do you wish to proceed?"
                onConfirm={handleDeleteReference}
            />
        </div>
    )
}

export default Reference;
